import { render, staticRenderFns } from "./culturalRelicsDetail.vue?vue&type=template&id=01fd7d00&scoped=true"
import script from "./culturalRelicsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./culturalRelicsDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./culturalRelicsDetail.vue?vue&type=style&index=0&id=01fd7d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fd7d00",
  null
  
)

export default component.exports